<template>
    <div id="search_form" class="modal custom-modal fade" :class="{'show': isShowForm}" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Search Options</h5>
            <!-- {{formParam}} -->
            <button
              ref="dismisModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <slot />
                </div>
              </div>
            </div>
  
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <center>
                      <!-- {{isSending}} -->
                      <button
                        @click.prevent="() => {
                            $refs.dismisModal.click();
                            $emit('clear')
                        }"
                        type="button"
                        class="btn btn-md btn-light"
                      >
                        <i class="fa fa-trash"></i> Clear Filter
                      </button>
                      <button
                        @click.prevent="() => {
                            $refs.dismisModal.click();
                            $emit('searchData')
                        }"
                        class="btn btn-md btn-success"
                        type="button"
                        :style="'margin-left:10px;'"
                      >
                        <i class="fa fa-search"></i> Search
                      </button>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Skeleton } from "vue-loading-skeleton";
  import { mapGetters } from "vuex";
  
  import Multiselect from "vue-multiselect";
  require("vue-multiselect/dist/vue-multiselect.min.css");
  import { Datetime } from "vue-datetime";
  // You need a specific loader for CSS files
  import "vue-datetime/dist/vue-datetime.css";
  import {
    formatDate,
    formatDateForMessage,
    getWhatsappNumberFromJid,
    formatSizes,
    currentDateTimeUTC
  } from "@/utils/helper";
  export default {
    components: {
      Skeleton,
      Multiselect
    },
    props: {
      searchData: {
        type: Function
      }
    },
    data() {
      return {
       
      };
    }, 
    computed: { 
    
    //   isShowForm: {
    //     get: function() {
    //       return this.$store.state.utils.showModal;
    //     },
    //     set: function(value) {
    //       this.$store.commit("utils/setModalData", value);
    //     }
    //   }
    },
    watch:{ 
    },
    filters: {
      capitalising: function(data) {
        var capitalized = [];
        data.split(" ").forEach(word => {
          capitalized.push(
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          );
        });
        return capitalized.join(" ");
      }
    },
    methods: {
      async clearSearch() {
        let newFormParam = {
          columnFilters: {
            start_date: "",
            end_date: "",
            instagram_account_id: "",
            brand_id: "",
            media_type: "",
            post_status: "",
            is_official: "1"
          },
          page: 1,
          perPage: 20,
          more_search: false,
          instagram_id: this.$route.query.instagram_id
        };
        await this.$store.dispatch(
          "instagramSchedule/actFormParamListLogStB",
          newFormParam
        );
        this.selectedContact = [];
        this.contactOptions = [];
        this.selectedProduct = [];
        this.productOptions = [];
        this.searchData();
        // console.log("newFormParam", newFormParam);
        var elem = this.$refs.dismisModal;
        elem.click();
      },
      async applySearch() {
        let newFormParam = this.formParam;
        newFormParam.more_search = true;
        await this.$store.dispatch(
          "instagramSchedule/actFormParamListLogStB",
          newFormParam
        );
        this.searchData();
        // console.log("newFormParam", newFormParam);
        var elem = this.$refs.dismisModal;
        elem.click();
      },
      asyncFindProduct(query) {
        if (this.selectedContact.length < 1) {
          return;
        }
        this.isLoading = true;
        this.productListParam.username = query;
        // console.log("selectedContact", this.selectedContact);
        this.productListParam.brand_id = this.selectedContact[0].id;
        this.$store
          .dispatch("instagramAccount/listOfficialS", this.productListParam)
          .then(response => {
            this.isLoading = false;
            this.productOptions = response.data.data;
          }) // sesuai kan dengan method di API
          .catch(error => {
            this.isLoading = false;
          });
      },
      limitText(count) {
        return `and ${count} other`;
      },
      customLabel({ name }) {
        return `${name}`;
      },
      customLabelProduct({ username }) {
        return `${username}`;
      },
      asyncFind(query) {
        this.isLoading = true;
        this.contactListParam.name = query;
        this.$store
          .dispatch("brand/list", this.contactListParam)
          .then(response => {
            this.isLoading = false;
            this.contactOptions = response.data.data;
          }) // sesuai kan dengan method di API
          .catch(error => {
            this.isLoading = false;
          });
      },
      clearAll() {
        this.selectedContact = [];
      },
      getMediaTypeList() {
        this.isLoading = true;
        this.$store
          .dispatch("instagramSchedule/getMediaTypeListS")
          .then(response => {
            this.isLoading = false;
            this.dataMediaTypeList = response.data;
          }) // sesuai kan dengan method di API
          .catch(error => {
            this.isLoading = false;
          });
      },
      async saveForm(isExit = 0) {
        this.$fire({
          title: "Are you sure you will continue this action?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          // console.log("rrrr", r);
          // return;
          if (r.value == true) {
            // console.log("valueee", r);
            this.isSending = await true;
            let action = "create";
            if (this.formParam.id != "") {
              action = "update";
            }
            await this.$store
              .dispatch("brand/" + action, this.formParam)
              .then(response => {
                // this.isSending = false;
                if (this.formParam.id == "") {
                  this.formParam = {
                    id: "",
                    name: "",
                    description: ""
                  };
                }
  
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 2000
                }).then(r => {});
                this.searchData();
                if (isExit == 1) {
                  var elem = this.$refs.dismisModal;
                  elem.click();
                  this.formParam = {
                    id: "",
                    name: "",
                    description: ""
                  };
                }
                this.isSending = false;
              })
              .catch(() => {
                this.isSending = false;
              });
          }
        });
      }
    },
    async created() {},
    beforeDestroy() {},
    mounted() {
      if ($(".floating").length > 0) {
        $(".floating")
          .on("focus blur", function(e) {
            $(this)
              .parents(".form-focus")
              .toggleClass(
                "focused",
                e.type === "focus" || this.value.length > 0
              );
          })
          .trigger("blur");
      }
    },
    name: "buttons-add"
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/ModalFilter/index.vue